<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item  label="申请人">
        <el-input v-model="queryInfo.applyUser" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryInfo.status" clearable>
          <el-option
          v-for="item in stateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="费用类型">
        <el-select v-model="queryInfo.feeType" clearable>
          <el-option
          v-for="item in typeList"
          :key="item.label"
          :label="item.label"
          :value="item.label"/>
        </el-select>
      </el-form-item>
      <el-form-item label="付款状态">
        <el-select v-model="queryInfo.payStatus" clearable>
          <el-option
          v-for="item in payList"
          :key="item.label"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
          v-model="queryInfo.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"/>
      </el-form-item>
      <el-form-item label="编号">
        <el-input v-model="queryInfo.eventId" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="情况说明">
        <el-input v-model="queryInfo.invoiceDescription" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="exportList">导出</el-button>
        <el-button type="primary" @click="paymentInform">已付款通知</el-button>
      </el-form-item>
    </el-form>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    :showSummary="true"
    sumText="汇总"
    @selection-change="handleSelection"
    :selectable="selectable"
    >
      <template #selection/>
      <template #operate={row} >
        <el-button type="text" size="small" @click="add('details', row.id)">查看详情</el-button>
      </template>
    </table-list>
    <application ref="Application" @addSuccess="query"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import Application from '../detailed/application.vue'
import { query, compApplyReimbursementExport, payedNotify } from '@/api/compApplyReimbursement'
import { ApprovalStatus, feeTypeList, payList } from '@/utils/constants'
export default {
  data () {
    return {
      queryInfo: {
        applyUser: '',
        payStatus: null,
        status: '',
        feeType: '',
        eventId: '',
        invoiceDescription: '',
        time: []
      },
      typeList: feeTypeList,
      stateList: ApprovalStatus,
      payList: payList,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [],
      loading: false,
      columnDefs: [
        { label: '编号', prop: 'eventId' },
        { label: '申请人', prop: 'applyUser', width: '80' },
        { label: '费用类型', prop: 'feeType' },
        { label: '申请日期', prop: 'createTime' },
        {
          label: '审核人',
          width: '80',
          formatter: (row) => {
            return row.auditPerson || row.preAuditPerson
          }
        },
        { label: '审核状态',
          formatter: (row) => {
            let status = ApprovalStatus.find(item => item.value === row.status)
            return status?.label || ''
          }
        },
        { label: '付款状态',
          formatter: (row) => {
            return row.payStatus ? '已付款' : '未付款'
          },
          prop: 'payStatus'
        },
        { label: '金额（元）', prop: 'feeAmount' },
        { label: '合同总金额', prop: 'contactTotalAmount', width: '100' },
        { label: '累计已付', prop: 'payedTotal', width: '80' },
        { label: '本次支付', prop: 'payedThisTime', width: '80' },
        { label: '剩余未付', prop: 'payedLeft', width: '80' },
        { label: '情况说明', prop: 'invoiceDescription' },
        { label: '操作', prop: 'operate' }
      ],
      abnormalList: [],
      payMoney: 0,
    }
  },
  components: {
    TableList,
    Application
  },
  methods: {
    selectable (item) {
      return (item.status === 1 && item.payStatus === false)
    },
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      query({
        pageSize: this.pageSize,
        pageNum: this.page,
        startTime: this.queryInfo.time?.[0] || '',
        endTime: this.queryInfo.time?.[1] || '',
        applyUser: this.queryInfo.applyUser,
        invoiceDescription: this.queryInfo.invoiceDescription,
        status: this.queryInfo.status,
        feeType: this.queryInfo.feeType,
        eventId: this.queryInfo.eventId,
        payStatus: this.queryInfo.payStatus
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    async paymentInform() {
      if (!this.abnormalList.length) {
        this.$message.warning('请选择数据！')
        return
      }
      const { code } = await payedNotify(this.abnormalList.map(v => v.eventId))
      if (code !== 0) return
      this.$message.success(`已付款通知成功，累计支付金额${this.payMoney}元`)
      this.getData()
      this.payMoney = 0
    },
    handleSelection (value) {
      this.abnormalList = value
      this.payMoney = this.paySum(this.abnormalList ? this.abnormalList.map(v => v.feeAmount) : []);
      console.log(this.payMoney);
    },
    paySum(arr) {
      if (!arr.length) return
      return arr.reduce(function(prev, curr, idx, arr) {
        return prev + curr;
      });
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    add (type = 'new', id = '') {
      this.$refs.Application.showDetails(type, id)
    },
    exportList () {
      compApplyReimbursementExport({
        startTime: this.queryInfo.time?.[0] || '',
        endTime: this.queryInfo.time?.[1] || '',
        applyUser: this.queryInfo.applyUser,
        status: this.queryInfo.status,
        feeType: this.queryInfo.feeType,
        eventId: this.queryInfo.eventId,
        payStatus: this.queryInfo.payStatus,
      }).then(res => {
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const elink = document.createElement("a");
        elink.download = '报销汇总.xls';
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      })
    }
  },
  mounted () {
    this.query()
  }
}
</script>
